import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./context/auth";
import Rotas from "./infra/routes";
import 'react-circular-progressbar/dist/styles.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Rotas />
      </Router>
    </AuthProvider>
  );
}

export default App;